export default {
  en: {    
    ERROR_PLEASE_TRY_AGAIN: 'Error: please try again',
    DOWNLOAD_REPORT: 'Download report',
    EXPORTING: 'Exporting',
    X: 'x'
  }
};